import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from './base.service';
import { Observable, throwError as observableThrowError, of } from 'rxjs';
import { ICacheMinTO } from 'src/app/models/cacheChanges/transportObject/cacheTO.min.interface';
import { ITicketValidationRequestTO } from 'src/app/models/ticket-validation/transportObjects/ticketValidationRequestTO.interface';
import { ITicketValidationResultTO } from 'src/app/models/ticket-validation/transportObjects/ticketValidationResultTO.interface';
import { map, publishReplay, refCount, catchError } from 'rxjs/operators';
import { IBetOutcomeWithPlayableStatusTO } from 'src/app/models/ticket/transportObjects/outcomeWithPlayableStatusTO.interface';
import { LoaderService } from '../loader.service';
import { UserActivityService } from '../userActivity.service';
import { NotificationService } from '../notification.service';
import { StorageService } from '../util/storage.service';

@Injectable()
export class CacheChangesProviderService extends BaseService {
  constructor(
    private http: HttpClient,
    protected loaderService: LoaderService,
    protected userActivityService: UserActivityService,
    protected notificationService: NotificationService,
    protected storage: StorageService) {
    super(loaderService, userActivityService, notificationService, storage);
  }

  updateOddsMinimal(
    sportIds: number[],
    competitionIds: number[],
    eventIds: number[],
    pageId: number,
    lastDeltaCacheNumber: string,
    isLive: boolean,
    expandedEventId: number,
    getAllChanges: boolean
  ): Observable<ICacheMinTO> {
    let newEventIds = [];
    if (expandedEventId && eventIds.findIndex(id => id === expandedEventId) === -1) {
      newEventIds.push(expandedEventId);
    }
    newEventIds = newEventIds.concat(eventIds);
    let cacheFilter = {};
    if (getAllChanges) {
      cacheFilter = {
        lastDeltaCacheNumber,
        pageId,
        ignoreBetTypesFilterOnEventIds: newEventIds,
        competitionIds: [],
        sportIds: [],
        isLiveFilter: isLive
      };
    } else {
      cacheFilter = {
        lastDeltaCacheNumber,
        pageId,
        ignoreBetTypesFilterOnEventIds: newEventIds,
        competitionIds,
        sportIds,
        isLiveFilter: isLive
      };
    }

    const params = new HttpParams();
    const body = JSON.stringify(cacheFilter);
    const url: string = this.cacheChangesUrl + 'CacheChangesMinimalByNumberAsStringAndFilterFromLocalCache';


    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as ICacheMinTO),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        if (err.error === '"DeltaCacheTooYoung"' || err.error === 'DeltaCacheTooYoung') {
          return of(null);
        } else {
          return observableThrowError(this.handleError(err));
        }
      }),
    );
  }
}
